// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"65148ad1","207":"b0df87c1","298":"beb0972b","468":"fe4ca38c","768":"2822a138","978":"5317b979"}[chunkId] + ".chunk.css";
};